import { FormattedMessage } from 'react-intl';
import { navigateToSelectedChannelRoute } from 'utils/history';
import Route from 'routes/Routes';
import { useSelectedLinkContext } from 'contexts';
import { trackEvent, GACommonEventAction, GAEventCategory } from 'services/googleAnalytics';
import { Grid } from '@mui/material';
import MenuGridPageLayout, {MenuCategory} from 'layouts/MenuGridPageLayout';
import {familyPortalTutorials, gettingTabletDockStarted, tabletTutorials, tabletUserGuide} from 'assets/category_cards/help/documents';

const GUIDES_PATH_PREFIX = '/pdf/help';

const HelpDocuments = () : JSX.Element => {
  const { selectedLink } = useSelectedLinkContext();

  const onUserGuideClick = () => {
    const userGuideFile = 'Guide utilisation Interface Guidée.pdf';

    trackEvent(GAEventCategory.HELP, GACommonEventAction.CLICK, userGuideFile);

    window.open(`${GUIDES_PATH_PREFIX}/${userGuideFile}`);
  };

  const createNavigationClickHandler = (route: Route) => () => navigateToSelectedChannelRoute(
    selectedLink,
    route,
  );

  return (
    <MenuGridPageLayout
      title={<FormattedMessage id="category.help.documents.description" />}
    >
      <MenuCategory
        altId='category.help.documents.user_guide'
        enableEvenIfNoSelectedLink
        image={tabletUserGuide}
        md={4}
        onClick={onUserGuideClick}
      />

      <MenuCategory
        altId='category.help.documents.tablet_tutorials'
        enableEvenIfNoSelectedLink
        image={tabletTutorials}
        md={4}
        onClick={createNavigationClickHandler(Route.TABLET_TUTORIALS)}
      />

      <Grid item md={4} xs={12} />

      <MenuCategory
        altId='category.help.documents.getting_started'
        enableEvenIfNoSelectedLink
        image={gettingTabletDockStarted}
        md={4}
        onClick={createNavigationClickHandler(Route.GETTING_STARTED)}
      />

      <MenuCategory
        altId='category.help.documents.family_portal_tutorials'
        enableEvenIfNoSelectedLink
        image={familyPortalTutorials}
        md={4}
        onClick={createNavigationClickHandler(Route.FAMILY_PORTAL_TUTORIALS)}
      />
    </MenuGridPageLayout>
  );
};

export default HelpDocuments;